import { pathOr } from 'ramda';

import {
  Box,
  Flex,
  HStack,
  Text,
  UserGroupBadge,
  VStack,
} from '@frontend/components';

import { useUserGroupBadgeLookup } from 'utils/multisite';

import HighlightOrDisplay from './HighlightOrDisplay';
import LabelText from './LabelText';
import PartCell from './PartCell';
import ValueText from './ValueText';

const OrderItemMatchCell = ({
  orderItemResult,
}: {
  orderItemResult: { data: Record<string, any>; highlight: any };
}) => {
  const getBadgeProps = useUserGroupBadgeLookup();
  const badgeProps = getBadgeProps(orderItemResult.data.ownerId);

  const filename = pathOr(null, ['data', 'filenames', 0], orderItemResult);
  const primaryFileUuid = pathOr(
    null,
    ['data', 'primaryFileUuid'],
    orderItemResult,
  );
  const href = `/orders/edit/${orderItemResult.data.orderNumber}?quote_item=${orderItemResult.data.quoteItemId}`;

  return (
    <Box alignContent="left">
      <Flex
        justifyContent="space-between"
        alignItems="center"
        paddingBottom={0.5}
        minWidth={0}
        width="100%"
      >
        <Flex alignItems="center" flexShrink={0}>
          <Text fontFamily="data" fontSize="sm">
            From{' '}
            <Text as="span" fontSize="sm" fontWeight="heavy">{` Order #`}</Text>
            <HighlightOrDisplay
              field="orderNumber"
              result={orderItemResult}
              textProps={{ fontWeight: 'heavy' }}
              useDataFont
            />
          </Text>
        </Flex>
        {badgeProps && (
          <Box
            flex={1}
            minWidth={0}
            marginLeft={1}
            display="flex"
            justifyContent="flex-end"
            overflow="hidden"
          >
            <UserGroupBadge
              maxWidth="100%"
              size="sm"
              name={badgeProps.name}
              colorPalette={badgeProps.colorPalette}
              icon={badgeProps.icon}
            />
          </Box>
        )}
      </Flex>
      <PartCell
        href={href}
        partResult={orderItemResult}
        resultOwnerId={orderItemResult.data.ownerId}
        filename={filename}
        primaryFileUuid={primaryFileUuid}
      />
      <HStack paddingTop={1}>
        <VStack alignItems="start" spacing={0}>
          <LabelText>Process</LabelText>
          <LabelText>Material</LabelText>
          <LabelText>Finish</LabelText>
          <LabelText>Total Price</LabelText>
          <LabelText>Unit Price</LabelText>
          <LabelText>Quantity</LabelText>
        </VStack>
        <VStack alignItems="start" spacing={0}>
          <HighlightOrDisplay field="process" result={orderItemResult} />
          <HighlightOrDisplay field="material" result={orderItemResult} />
          <HighlightOrDisplay field="finishes" result={orderItemResult} />
          <ValueText useDataFont>
            {orderItemResult.data.price ? orderItemResult.data.price : '--'}
          </ValueText>
          <ValueText useDataFont>
            {orderItemResult.data.unitPrice
              ? orderItemResult.data.unitPrice
              : '--'}
          </ValueText>
          <ValueText useDataFont>
            {orderItemResult.data.quantity
              ? orderItemResult.data.quantity
              : '--'}
          </ValueText>
        </VStack>
      </HStack>
    </Box>
  );
};

export default OrderItemMatchCell;
